import { PatientVisit } from "../../amplify/appsync/search-patients";
import { formatAnnotationsPluginMarks, horizontalAnnotationsPlugin, pointsPlugin, tooltipsNumericsPlugin, tooltipsSummaryPlugin } from "./plugins";

export const PLOT_HEIGHT = 140;

export const getVisitSummaryOpts = (width: number, setCursPos: any, relatedPatientVisits: any, navigateToPatientVisit: any) => {
    width = width * 0.9 // to account for the padding caused by the modal
    const opt: any = {
        id: `multivisit-summary`,
        width: width,
        height: 120,
        focus: false,
        legend: {
            show: false
        },
        cursor: {
            // set: (left: any, top: any) => {
            //     setCursPos({
            //         left: left,
            //         top: top,
            //     })
            // },
            // get: () => ({left: cursPos.left, top: cursPos.top}),
            focus: {
                prox: 5,
            },
            sync: {
                key: 'multivisit',
            },
        },
        scales: {
            x: {
                time: true,
                // min: min,
                // max: max,
            },
            y: {
            }
        },
        axes: [{
            show: true,
            font: "12px Arial",
            labelSize: 30,
            size: 50,
        }, {
            show: true,
            label: "Timeline",
            labelGap: 8,
            grid: {
                show: true,
            },
            values: (u: any, t: any) => t.map((v: number) => {
                // if (v === 0) {
                //     return "Labs";
                // } else if (v === -1) {
                //     return "Meds";
                // } else {
                //     return "";
                // }
                return "";
            }),
        }],
        series: [
            {},
            {
                label: "Emergency",
                paths: () => null, // Disables line
                points: {
                    fill: 'red', // fill color on mouseover
                },
                stroke: 'red',
                width: 4,
            },
            {
                label: "Inpatient",
                paths: () => null, // Disables line
                points: {
                    fill: 'orange', // fill color on mouseover
                },
                stroke: 'orange',
                width: 4,
            },
            {
                label: "Outpatient",
                paths: () => null, // Disables line
                points: {
                    fill: 'green', // fill color on mouseover
                },
                stroke: 'green',
                width: 4,
            },
            {
                label: "Ambulatory",
                paths: () => null, // Disables line
                points: {
                    fill: 'purple', // fill color on mouseover
                },
                stroke: 'purple',
                width: 4,
            },
            {
                label: "Other",
                paths: () => null, // Disables line
                points: {
                    fill: 'gray', // fill color on mouseover
                },
                stroke: 'gray',
                width: 4,
            },
        ],
        plugins: [
            pointsPlugin(),
            tooltipsSummaryPlugin(setCursPos, relatedPatientVisits, navigateToPatientVisit),
            horizontalAnnotationsPlugin(formatAnnotationsPluginMarks(relatedPatientVisits)),
        ],
        hooks: {
        },
    }

    return opt;
}

const getVisitOptsMinMax = (visitSummaryPlotData: any) => {
    let min = null;
    let max = null;
    if (visitSummaryPlotData[0].length > 0) {
        min = visitSummaryPlotData[0][0];
    }
    if (visitSummaryPlotData[0].length > 0) {
        max = visitSummaryPlotData[0][visitSummaryPlotData[0].length - 1];
    }
    if (min !== null && max !== null && min === max) {
        min = min - 60 * 30;
        max = max + 60 * 30;
    }
    return [min, max]
}

export const getVisitOpts = (width: number, plotType: string, showXAxis: boolean, visitSummaryPlotData: any, cursPos: any, setCursPos: any, relatedPatientVisits: any, navigateToPatientVisit: any) => {
    width = width * 0.9 // to account for the padding caused by the modal
    const opt: any = {
        id: `multivisit-${plotType}`,
        width: width,
        height: showXAxis ? PLOT_HEIGHT + 40 : PLOT_HEIGHT,
        focus: false,
        legend: {
            show: false
        },
        cursor: {
            set: (left: any, top: any) => {
                setCursPos({
                    left: left,
                    top: top,
                })
            },
            get: () => ({left: cursPos.left, top: cursPos.top}),
            sync: {
                key: 'multivisit',
            },
        },
        scales: {
            x: {
                time: true,
                min: getVisitOptsMinMax(visitSummaryPlotData)[0],
                max: getVisitOptsMinMax(visitSummaryPlotData)[1],
            },
            y: {
            }
        },
        axes: [{
            show: true,
            font: showXAxis ? "12px Arial" : "0px Arial",
            labelSize: showXAxis ? 30 : 0,
            size: showXAxis ? 50 : 4,
        }, {
            show: true,
            label: plotType,
            labelGap: 8,
            grid: {
                show: true,
            },
        }],
        series: plotType === "NBP" ? 
            [
                {},
                {
                    label: plotType,
                    stroke: "blue",
                    dash: [2, 4],
                    points: {
                        show: true, // shows the points
                        space: 0, // minimum spacing to display points
                    },
                },
                {
                    label: plotType,
                    stroke: "blue",
                    dash: [2, 4],
                    points: {
                        show: true, // shows the points
                        space: 0, // minimum spacing to display points
                    },
                },
                {
                    label: plotType,
                    stroke: "purple",
                    points: {
                        show: true, // shows the points
                        space: 0, // minimum spacing to display points
                    },
                },
                {
                    label: plotType,
                    stroke: "purple",
                    points: {
                        show: true, // shows the points
                        space: 0, // minimum spacing to display points
                    },
                },
            ] : 
            [
                {},
                {
                    label: plotType,
                    stroke: "blue",
                    dash: [2, 4],
                    points: {
                        show: true, // shows the points
                        space: 0, // minimum spacing to display points
                    },
                },
                {
                    label: plotType,
                    stroke: "purple",
                    points: {
                        show: true, // shows the points
                        space: 0, // minimum spacing to display points
                    },
                },
            ],
        bands: plotType === "NBP" ? [
            {
                series: [1, 2],
                fill: "rgba(150, 38, 188, 0.1)",
            },
        ] : null,
        plugins: [
            tooltipsNumericsPlugin(setCursPos, relatedPatientVisits, navigateToPatientVisit),
        ],
        hooks: {
        },
    }

    return opt;
}
